'use client';
import { useEffect } from 'react';

const RELOADED_FLAG = 'chunkErrorReloaded';

export function ChunkErrorReloadInitializer() {
  useEffect(() => {
    const clearGuardTimer = window.setTimeout(() => {
      try {
        sessionStorage.removeItem(RELOADED_FLAG);
      } catch {}
    }, 15_000);

    const reloadOnce = () => {
      try {
        if (sessionStorage.getItem(RELOADED_FLAG)) return;
        sessionStorage.setItem(RELOADED_FLAG, '1');
      } catch {}
      window.location.reload();
    };

    const onError = (event: ErrorEvent) => {
      if (event.error?.name === 'ChunkLoadError') reloadOnce();
    };

    const onUnhandledRejection = (event: PromiseRejectionEvent) => {
      if (event.reason?.name === 'ChunkLoadError') reloadOnce();
    };

    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onUnhandledRejection);
    return () => {
      window.clearTimeout(clearGuardTimer);
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onUnhandledRejection);
    };
  }, []);

  return null;
}
